// export const urlDefault = 'http://middleware-aigmex-desarrollo.nuvem.cloud/'; //middleware pruebas internas sin https
// export const urlDefault = 'http://localhost/middlewareSegurosAigMex/'; //middleware pruebas internas sin https
export const urlDefault = 'https://middleware-aigmex-desarrollo-uat.nuvem.cloud/'; //middleware pruebas internas con https
// export const urlDefault = 'http://localhost:8081/'; //middleware pruebas internas con https
// export const urlDefault = 'https://middleware-aigmex-produccion.nuvem.cloud/'; //middleware produccion con https
//export  const urlDefault ='http://middlewaretest-env.eba-wmpvbpsx.us-west-2.elasticbeanstalk.com/'
// export const urlDefault =
//   "http://midd-desarollo-interno-php-8.us-west-2.elasticbeanstalk.com/"; //PHP 8
// export const urlDefault = 'https://middleware-aigmex-desarrollo-uat.nuvem.cloud/'; //middleware pruebas con https

// export const urlBackOffice = 'https://backoffice-aigmex-desarrollo-uat.nuvem.cloud/';
export const urlBackOffice = 'https://aigsegurosmexico.com/';

export const urlPhp8Default = 'https://middleware-desarrollo.aigsegurosmexico.com/';
// export const urlPhp8Default = 'https://middleware-produccion-php-8.aigsegurosmexico.com/';
// export const urlPhp8Default = 'http://localhost/middlewareSeguros8/';
export const enableGCM = true;
export const urlPhp8 = process.env.REACT_APP_URL_PHP_8 || urlPhp8Default;

const urlBaseDefaulMiddServicios = 'https://servicios-pruebas.nuvem.cloud/';

const urlDefaulMiddServicios = process.env.REACT_APP_URL_MIDD_SERVICIOS || urlBaseDefaulMiddServicios;

export const urlBase = process.env.REACT_APP_URL_BASE || urlDefault;

const ambienteDefault = 'desarrollo';
// const ambienteDefault = "produccion";

export let ambienteAplicacion = process.env.REACT_APP_AMBIENTE || ambienteDefault; //Utilizado solo para produccion
export const ambientes = {
  DEV: 'desarrollo',
  PROD: 'produccion',
};

export const isDev = () => ambienteAplicacion === ambientes.DEV;
export const isProd = () => ambienteAplicacion === ambientes.PROD;

export const emp = 'AIGMEX';
export const plataforma1 = 'WEB';
export let ambiente = `&ambiente=${ambienteAplicacion}`; //Utilizado solo para produccion

export const controlador = 'frontend/web/index.php?r=';
export const empresa = '&empresa=' + emp;
export const plataforma = '&plataforma=' + plataforma1;

export const baseBody = { empresa: emp, ambiente: ambienteAplicacion };

export const URL_BASE_PHP_7 = `${urlBase}${controlador}`;
export const URL_BASE_PHP_8 = `${urlPhp8}${controlador}`;

/************************************ AIG MEX ******************************************************************************************************************************** */

export const urlVerificarEmailOkta = `${urlBase}${controlador}site/verificar-auth-okta`;
export const urlAutenticacionOkta = `${urlDefaulMiddServicios}api/okta/${emp}/FRONT/ingreso`;

//SSO
export const response_type = `code`;
export const urlAuthSSO = `${urlPhp8}${controlador}api/auth/sso/{function}&ambiente=AIGGO`;
export const urlAuthSSOLogin = urlAuthSSO.replace('{function}', 'login');
export const urlAuthSSOLogout = urlAuthSSO.replace('{function}', 'logout');
export const urlFindErrorCode = `${urlPhp8}${controlador}api/auth/sso/consulta-codigo-error`;
//export const urlUploadFile = `${urlBase}${controlador}app/upload-file&empresa=${emp}`;
export const urlUploadFile = `${urlPhp8}${controlador}app/upload-file&empresa=${emp}`;

export const urlGetKardexCerificadosTbta = `${urlBase}${controlador}polizas/generar-reporte-travel`;

// export const urlCatalogosCotizadorMex = `${urlBase}${controlador}carrito/catalogos-cotizador`;
// export const urlActualizarCotizadorMex = `${urlBase}${controlador}carrito/actualizar-cotizacion`;

// export const urlGuardarPlanes = `${urlBase}${controlador}carrito/guardar-planes`;

// export const urlGetPlanes = `${urlBase}${controlador}carrito/get-planes`;
export const urlSeccionPago = `${urlBase}${controlador}carrito/seccion-pago`;

export const urlTarifacionCotizadorMex = `${urlBase}${controlador}carrito/tarifacion-cotizacion`;
export const urlLoginMex = `${urlBase}${controlador}clientes/iniciar-sesion-aes`;
// export const urlLoginMex = `${urlBase}${controlador}api/auth/login-aes`;
// export const urlResumenCotizadorMex = `${urlBase}${controlador}carrito/resumen-cotizacion`;

// export const urlListadoCotizaciones = `${urlBase}${controlador}leads/obtener-cotizaciones-usuario`;

export const urlValidacionesCambioContrasenia = `${urlBase}${controlador}usuarios/validaciones-cambiarcontrasenia-mexico`;
export const urlCambiarContrasenias = `${urlBase}${controlador}clientes/cambiar-contrasenias`;
export const urlCambiarContraseniaProceso = `${urlBase}${controlador}clientes/cambiar-contrasenia-proceso`;
export const urlRecuperarContraseniaMex = `${urlBase}${controlador}clientes/recuperar-contrasenia`;

// export const urlEmisionPoliza = `${urlBase}${controlador}polizas/datos-emision`;

// export const urlGuardarContratante = `${urlBase}${controlador}polizas/guardar-contratante`;
// export const urlGuardarContratantePymes = `${urlBase}${controlador}pymes/guardar-contratante`;
// export const urlListarAsegurados = `${urlBase}${controlador}polizas/listar-asegurados`;
// export const urlSeccionCargaContratante = `${urlBase}${controlador}polizas/seccion-carga-contratante`;
// export const urlSeccionCargaAsegurado = `${urlBase}${controlador}polizas/seccion-carga-asegurado`;

export const urlPago = `${urlBase}${controlador}polizas/pago`;

/*
    DETALLE POLIZA
*/

export const urlCertificados = `${urlBase}${controlador}certificados/catalogos-certificados`;
export const urlCertificadosCrear = `${urlBase}${controlador}certificados/creacion-individual-certificados`;
export const urlCertificadosCreacionMasiva = `${urlBase}${controlador}certificados/creacion-certificados-masivos`;
export const urlCertificadosEliminar = `${urlBase}${controlador}certificados/eliminar-certificados`;
// export const urlVigenciaGeneral = `${urlBase}${controlador}vigencias/generar-vigencia-poliza`;
// export const urlGuardarVigenciaGeneral = `${urlBase}${controlador}vigencias/guardar-vigencia-poliza`;

// export const urlGuardarVigenciaLF = `${urlBase}${controlador}lineas-financieras/guardar-vigencia-poliza`;
// export const urlGenerarVigenciaLF = `${urlBase}${controlador}lineas-financieras/generar-vigencia-poliza`;
/**
 * URL HOGAR
 */

// export const urlConsultarValorGo4It = `${urlBase}${controlador}hogar/go4-it`;
// export const urlDescargarPDFGo4It = `${urlBase}${controlador}hogar/descargar-pdf-go4-it`;

/*
+
    URLS APINDIVIDUAL
*/

// export const urlCatalogosCotizador = `${urlBase}${controlador}carrito/catalogos-cotizador`;
// export const urlActualizarCotitzacionAP = `${urlBase}${controlador}carrito/actualizar-cotizacion`;

/*
    URL SECCIONES PAGINAS
*/

export const urlCatalogoSeccion = `${urlBase}${controlador}api/v2/site/home`;

/*
    URL RECOTIZACION PYMES
*/
// export const urlRecotizacionPymes = `${urlBase}${controlador}carrito/recotizacion-pymes`;
// export const urlListarAseguradosPymes = `${urlBase}${controlador}pymes/listar-asegurados`;
// export const urlActualizarAseguradosPymes = `${urlBase}${controlador}pymes/actualizar-asegurados`;
// export const urlVigenciaPolizaPymes = `${urlBase}${controlador}pymes/generar-vigencia-poliza`;
// export const urlGuardarVigenciaPolizaPymes = `${urlBase}${controlador}pymes/guardar-vigencia-poliza`;

/**
 * HOGAR EMISION
 */

// export const urlGuardarVigenciaHOGAR = `${urlBase}${controlador}hogar/save-vigencia-poliza`;
// export const urlGenerarVigenciaHOGAR = `${urlBase}${controlador}hogar/vigencia-poliza`;
//CATALOGO ASEGURADO
// export const urlCatalogoAsegurado = `${urlBase}${controlador}v2/poliza/catalogo-asegurado`;

/**
 * MARINEINLAND EMISION
 */
export const urlGenerarVigenciaMarine = `${urlBase}${controlador}api/v1/marine/guardar-vigencia`;
/**
 * VALIDACIONES DE EMISION
 */
// export const urlValidacionesRecuperacion = `${urlBase}${controlador}polizas/validaciones-recuperar-cotizacion-poliza`;
export const urlValidacionesRecuperacionV2 = `${urlBase}${controlador}api/v2/validaciones/validaciones-recuperar-cotizacion-poliza`;
/************************************ FIN AIG MEX ******************************************************************************************************************************** */

/* SEGUKIDS */
export const urlCotizacionSegukids = `${urlPhp8}${controlador}api/v1/segukids/crear-carrito`;
export const urlMaxChildSegukids = `${urlPhp8}${controlador}api/v1/segukids/catalogo-max-hijos`;
export const urlDataPlanes = `${urlPhp8}${controlador}api/v1/segukids/get-planes`;
export const urlPlanSelected = `${urlPhp8}${controlador}api/v1/segukids/set-planes`;
export const urlActualizarSegukids = `${urlPhp8}${controlador}api/v1/segukids/guardar-contratante`;
export const urlcrearPolizaSKT = `${urlPhp8}${controlador}api/v1/segukids-emision/crear-poliza`;
export const urlcatalogoSKT = `${urlPhp8}${controlador}api/v1/segukids-emision/catalogos-contratante`;
export const urlGuardarContratanteSKT = `${urlPhp8}${controlador}api/v1/segukids-emision/guardar-contratante`;
export const urlListAseguradoSKT = `${urlPhp8}${controlador}api/v1/segukids-emision/listar-asegurados`;
export const urlGuardarAseguradoSKT = `${urlPhp8}${controlador}api/v1/segukids-emision/actualizar-asegurados`;
export const urlNumHijos = `${urlPhp8}${controlador}api/v1/segukids/catalogo-num-hijos`;
export const urlCatalogoPagador = `${urlPhp8}${controlador}api/v1/segukids-emision/catalogos-pagador`;
export const urlGuardarPagador = `${urlPhp8}${controlador}api/v1/segukids-emision/guardar-pagador`;
export const urlCatalogoCotizador = `${urlPhp8}${controlador}api/v1/segukids/get-datos-contratante`;
export const urlDonwloadVoucher = `${urlPhp8}${controlador}comprobantes/comprobante/descargar-comprobante`;
export const urlRecuperarPoliza = `${urlPhp8}${controlador}api/v1/segukids-emision/paso-pendiente-pre-poliza`;

// export const urlValidateApiKey = `${urlPhp8}${controlador}api/v1/auth/validate-api-key&XDEBUG_SESSION_START=name`;
export const urlValidateApiKey = `${urlPhp8}${controlador}api/v1/auth/validate-api-key&XDEBUG_SESSION_START=name`;

/* Formulario Facturación QR*/
export const urlCatalogosFacQr = `${urlPhp8}${controlador}api/v1/parametros/find-parametro${empresa}${plataforma}`;
export const urlFindRfcFacQr = `${urlPhp8}${controlador}api/v1/contratante/verificar-datos-by-rfc${empresa}${plataforma}`;
export const urlExtractDataQr = `${urlPhp8}${controlador}api/v1/contratante/verificar-constancia${empresa}${plataforma}`;
export const urlContinuarDataQr = `${urlPhp8}${controlador}api/v1/contratante/continuar-contratante${empresa}${plataforma}`;
export const urlContinuarRecuperarDataQr = `${urlPhp8}${controlador}api/v1/contratante/atras-contratante${empresa}${plataforma}`;
export const urlUploadPdfConstancia = `${urlPhp8}${controlador}api/v1/contratante/verificar-datos-fiscales-pdf${empresa}${plataforma}`;
/************************************ FIN AIG MEX ******************************************************************************************************************************** */
/* Encuestas */
export const urlLinkEncuestas = `${urlPhp8}${controlador}v2/encuestas/get-link-encuesta&idPoliza=`;
export const registroEncuesta = `${urlPhp8}${controlador}v2/encuestas/completar-encuesta&idPoliza=`;
export const rechazoEncuesta = `${urlPhp8}${controlador}v2/encuestas/rechazar-encuesta&idPoliza=`;
export const urlValidarPantallaPago = `${urlBase}${controlador}api/v1/pago/validar-pantalla-pago`;
export const urlCancelarTokensCorreo = `${urlBase}${controlador}api/v1/pago/cancelar-tokens-correo`;
export const urlConsultarCodigoError = `${urlBase}${controlador}api/v1/error-code/consultar-codigo-error`;

export const urlTrackingLeadsV2 = `${urlPhp8}${controlador}api/v2/leads/save-tracking`;
/* Banners Home */
export const urlBannersHome = `${urlPhp8}${controlador}api/v1/banners/welcome-home${empresa}${plataforma}`;
